import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

/**
 * Όροι χρήσης και πολιτική απορρήτου (§10, §11).
 *
 * Το κείμενο ζει στο i18n και όχι σε CMS: αλλάζει σπάνια, πρέπει να είναι
 * μεταφράσιμο και δεν αξίζει ούτε βάση δεδομένων ούτε πάροχο περιεχομένου.
 */
export default function LegalPage() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const section = pathname.includes('privacy') ? 'privacy' : 'terms'

  const paragraphs = t(`legal.${section}Body`, { returnObjects: true }) as string[]

  return (
    <main className="mx-auto flex min-h-full w-full max-w-2xl flex-col gap-6 px-5 py-8">
      <header>
        <Link to="/" className="text-sm font-semibold uppercase tracking-widest text-brand-700">
          B2Vend
        </Link>
        <h1 className="mt-2 text-2xl font-bold text-gray-900">{t(`legal.${section}`)}</h1>
        <p className="mt-1 text-sm text-gray-500">{t('legal.updated')}</p>
      </header>

      <article className="flex flex-col gap-4 text-sm leading-relaxed text-gray-700">
        {paragraphs.map((paragraph) => {
          const isHeading = paragraph.startsWith('## ')
          return isHeading ? (
            <h2 key={paragraph} className="mt-2 text-base font-semibold text-gray-900">
              {paragraph.slice(3)}
            </h2>
          ) : (
            <p key={paragraph}>{paragraph}</p>
          )
        })}
      </article>

      <footer className="border-t border-gray-200 pt-4 text-sm">
        <Link
          to={section === 'terms' ? '/privacy' : '/terms'}
          className="font-medium text-brand-700 underline"
        >
          {t(section === 'terms' ? 'legal.privacy' : 'legal.terms')}
        </Link>
      </footer>
    </main>
  )
}
